import clsx from 'clsx';
import { Image } from '@repo/ui/Image';
import { FC } from 'react';

type ResultCardProps = {
  carsFound: string;
};

const block1: string[] = ['hatch', 'suv', 'van', 'ute'];
const block2: string[] = ['van', 'ute', 'hatch', 'suv'];
const block3: string[] = ['ute', 'hatch', 'suv', 'van'];

const ImagesTrack: FC<{ className?: string; images: string[] }> = ({ className, images }) => (
  <div className={clsx('grid gap-4', className)}>
    {images.map((image) => (
      <div
        className="relative m-auto size-full min-h-28 min-w-28 overflow-hidden rounded-xs shadow-elevation-2dp"
        key={image}
      >
        <Image
          src={`/images/components/PersonalizedQuote/${image}.svg`}
          width={112}
          height={112}
          alt=""
          className="size-full object-cover"
        />
      </div>
    ))}
    {images.map((image) => (
      <div
        className="relative m-auto size-full min-h-28 min-w-28 overflow-hidden rounded-xs shadow-elevation-2dp"
        key={image}
      >
        <Image
          src={`/images/components/PersonalizedQuote/${image}.svg`}
          width={112}
          height={112}
          alt=""
          className="size-full object-cover"
        />
      </div>
    ))}
  </div>
);

export const ResultCard: FC<ResultCardProps> = ({ carsFound }) => (
  <div className="grid gap-4 overflow-hidden rounded-xs bg-bac-tie1 sm:flex sm:gap-4" data-testid="ResultCard">
    <div className="relative h-60 w-full overflow-hidden sm:max-w-58 sm:shrink-0">
      <div className="grid animate-result-card-tracks grid-cols-[1fr_1fr_1fr] gap-4 sm:grid-cols-2">
        <ImagesTrack images={block1} />
        <ImagesTrack className="-translate-y-8" images={block2} />
        <ImagesTrack className="sm:hidden" images={block3} />
      </div>
    </div>
    <div className="grid gap-4 p-4 sm:flex sm:flex-col sm:gap-4">
      <div className="c-fs-h5 font-extrabold text-tex-def-tie1" data-testid="result-car-title">
        {`We\u2019ve found ${carsFound} Carma cars that match your budget and preferences.`}
      </div>
      <div className="c-fs-body2 font-normal text-tex-def-tie1">
        We add new cars every day, so when you\u2019re ready to purchase you\u2019ll be spoilt for choice.
      </div>
    </div>
  </div>
);
